import { render, staticRenderFns } from "./benInfo.vue?vue&type=template&id=133cfc0c"
import script from "./benInfo.vue?vue&type=script&lang=js"
export * from "./benInfo.vue?vue&type=script&lang=js"
import style0 from "./benInfo.vue?vue&type=style&index=0&id=133cfc0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports